import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { overlay } from 'overlay-kit';
import { cancelPendingModals } from '@/shared/utils/modalCancellation';
export const GlobalDialogManager = () => {
  const router = useRouter();
  const closeAll = () => {
    cancelPendingModals();
    overlay.unmountAll();
  };
  useEffect(() => {
    router.events.on('routeChangeStart', closeAll);
    return () => {
      router.events.off('routeChangeStart', closeAll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};